import { render, staticRenderFns } from "./MenuVue.vue?vue&type=template&id=c01e2f94&"
import script from "./MenuVue.vue?vue&type=script&lang=js&"
export * from "./MenuVue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports